export const SectionAboutUsTranslationsUk = {
  'About Us': 'Про нас',
  'AniraK...':
    "AniraKids — прокат святкових суконь і костюмів для дітей та дорослих. Обирайте вбрання з нашого каталогу для свята, весілля або сімейної фотосесії.",
};
